import { render, staticRenderFns } from "./DashboardConcesionario.vue?vue&type=template&id=28ccc5a1"
import script from "./DashboardConcesionario.vue?vue&type=script&lang=js"
export * from "./DashboardConcesionario.vue?vue&type=script&lang=js"
import style0 from "./DashboardConcesionario.vue?vue&type=style&index=0&id=28ccc5a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports